/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { Box, Typography } from "@mui/material";
import { HeatSeries } from "src/store/api/generatedApi";
import { NumberFormatter } from "hooks/serialisers/numbers";
import { useTenantTranslation } from "hooks/formatters";
import { TrafficLight } from "./TrafficLight";
import { getSourceValue } from "../utils";

export const PRICE_DIFF_GREEN_THRESHOLD = 2;
export const PRICE_DIFF_YELLOW_THRESHOLD = 5;

type TrafficLightColor = "success" | "warning" | "error" | "disabled";

const getPriceDiffTrafficLightColor = (
  diff: number | null | undefined
): TrafficLightColor => {
  if (diff === null || diff === undefined) return "disabled";
  if (diff <= PRICE_DIFF_GREEN_THRESHOLD) return "success";
  if (diff <= PRICE_DIFF_YELLOW_THRESHOLD) return "warning";
  return "error";
};

export const ChargedPriceCell = ({
  row,
  source,
  ignoredMaterials,
  formatNumber,
}: {
  row: HeatSeries;
  source: string;
  ignoredMaterials: Set<string>;
  formatNumber: NumberFormatter;
}) => {
  const { t } = useTenantTranslation();
  const sourceValue = getSourceValue(
    source,
    row.mixes,
    "$t(chargedPrice)",
    ignoredMaterials
  );

  if (sourceValue === null) {
    return (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ textAlign: "center", width: "100%", opacity: 0.4 }}
      >
        {t("noData")}
      </Typography>
    );
  }

  return (
    <Typography variant="body2" sx={{ textAlign: "center", width: "100%" }}>
      {formatNumber(sourceValue.value, {
        decimalPlaces: sourceValue.decimalPlaces,
      })}
    </Typography>
  );
};

export const PriceTrafficLightCell = ({ row }: { row: HeatSeries }) => {
  const diff = row.summary_data?.find(
    (s) => s.name === "scrapEyePriceDiff"
  )?.value;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <TrafficLight color={getPriceDiffTrafficLightColor(diff)} />
    </Box>
  );
};
